module.exports = __webpack_public_path__ + "img/dialog-img-02.76135ae8.png";